import React from 'react';

import styled from 'styled-components';

import { Animation } from 'components/lottie-animations/loyalty-opt-in-modal';

const LottieWrapper = styled.div`
  margin-bottom: -40px;
`;

const OptInDefaultAnimation = () => (
  <LottieWrapper data-testid="opt-in-default-animation">
    <Animation />
  </LottieWrapper>
);

export default OptInDefaultAnimation;
